const ReportPagination = ({
  currentPage,
  totalPages,
  onPageChange,
  isAuthenticated,
  onAuthRequired,
}) => {
  if (totalPages <= 1) {
    return null;
  }

  const handlePageClick = (page) => {
    if (page < 1 || page > totalPages) {
      return;
    }

    if (page > 2 && !isAuthenticated) {
      onAuthRequired(page);
      return;
    }

    if (page !== currentPage) {
      onPageChange(page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const renderPageNumbers = () => {
    const visiblePages = [];
    const range = 1;
    const start = Math.max(currentPage - range, 1);
    const end = Math.min(currentPage + range, totalPages);

    if (start > 1) {
      visiblePages.push(1);
      if (start > 2) {
        visiblePages.push("...");
      }
    }

    for (let page = start; page <= end; page += 1) {
      visiblePages.push(page);
    }

    if (end < totalPages) {
      if (end < totalPages - 1) {
        visiblePages.push("...");
      }
      visiblePages.push(totalPages);
    }

    return visiblePages;
  };

  return (
    <div className="flex font-body text-14 items-center justify-center space-x-1 sm:space-x-2">
      <button
        onClick={() => handlePageClick(currentPage - 1)}
        disabled={currentPage === 1}
        className="flex justify-center items-center gap-5 md:px-4 py-2 border-0 text-pl-accent rounded-md cursor-pointer disabled:text-pl-text-tertiary disabled:cursor-not-allowed"
      >
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.1666 8.06694H3.83325M3.83325 8.06694L8.49992 12.7336M3.83325 8.06694L8.49992 3.40027" stroke="currentColor" strokeOpacity="0.8" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <div className="md:flex hidden">Previous</div>
      </button>

      {renderPageNumbers().map((page, index) =>
        page === "..." ? (
          <span key={`ellipsis-${index}`} className="px-2 select-none">
            ...
          </span>
        ) : (
          <button
            key={`page-${page}`}
            onClick={() => handlePageClick(page)}
            className={`h-25 min-w-25 px-1 flex items-center justify-center rounded cursor-pointer text-pl-accent ${
              page === currentPage ? "bg-pl-accent text-white opacity-80" : ""
            }`}
          >
            <div>{page}</div>
          </button>
        )
      )}

      <button
        onClick={() => handlePageClick(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="flex justify-center items-center gap-5 md:px-4 py-2 border-0 text-pl-accent rounded-md cursor-pointer disabled:text-pl-text-tertiary disabled:cursor-not-allowed"
      >
        <div className="md:flex hidden">Next</div>
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" className="fill-current" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.83325 8.06694H13.1666M13.1666 8.06694L8.49992 3.40027M13.1666 8.06694L8.49992 12.7336" stroke="currentColor" strokeOpacity="0.8" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </div>
  );
};

export default ReportPagination;
